// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"ff998909","631":"ff998909","833":"ff998909"}[chunkId] + ".chunk.css";
};